import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { FaAngleDown, FaCheck } from 'react-icons/fa';
import './style.scss';

const MobileSelectSeasons = ({
  title,
  defaultSelect,
  options,
  changeSeason,
}) => {
  const [isSelectVisible, setIsSelectVisible] = useState(false);
  const [currentSelected, setCurrentSelected] = useState(defaultSelect);
  const [marginTop, setMarginTop] = useState(0);
  const translations = useSelector(state => state.translations);
  const selectContainerRef = useRef(null);

  useEffect(
    () => {
      let marginCompensation = window.innerHeight - selectContainerRef.current?.offsetHeight;
      setMarginTop(marginCompensation);
    },
    [isSelectVisible],
  );

  const handleOpenSelectClick = e => {
    e.stopPropagation();
    e.preventDefault();
    setIsSelectVisible(true);
  };

  const handleSelectClick = e => {
    e.stopPropagation();

    const newId = e.target.textContent.substr(
      e.target.textContent.indexOf(
        `${translations.vcard_access_abbreviationSeason_label} `,
      ) + translations.vcard_access_abbreviationSeason_label.length,
    );

    changeSeason(Number(newId));
    setCurrentSelected(e.target.textContent);
    setIsSelectVisible(false);
  };

  return (
    <>
      <div className="mobile-select-seasons" onClick={handleOpenSelectClick}>
        <span>{defaultSelect}</span>
        <FaAngleDown className="mobile-select-seasons__icon" />
      </div>
      {/*<---Input */}
      {isSelectVisible && (
        <div className="select-seasons">
          <div
            className="select-seasons__container"
            ref={selectContainerRef}
            style={{ marginTop }}
          >
            <h3>{title}</h3>
            <ul className="select-seasons__container__options">
              {options.map(option => (
                <li key={option.id} onClick={handleSelectClick}>
                  <span>{option.value}</span>
                  {currentSelected === option.value && (
                    <FaCheck className="icon" />
                  )}
                </li>
              ))}
            </ul>
            <button
              className="select-seasons__container__close-button"
              onClick={() => setIsSelectVisible(false)}
            >
              CERRAR
            </button>
          </div>
        </div>
      )}
      {/*<---Select */}
    </>
  );
};

export default MobileSelectSeasons;
